// LocalStorage cache for the Client Reporting page, mirroring dashboardCache.js:
// show the user's last-viewed accounts and growth chart instantly on mount,
// then refresh from the server in the background.

const VERSION = 3;
const PREFIX = `risklo-client-reporting.v${VERSION}`;

function cacheKey(email) {
  return `${PREFIX}::${String(email || '').trim().toLowerCase()}`;
}

export function readClientReportingCache(email) {
  if (!email || typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(cacheKey(email));
    if (!raw) return null;
    const cached = JSON.parse(raw);
    if (!cached || !Array.isArray(cached.clients)) return null;
    return cached;
  } catch (_err) {
    return null;
  }
}

export function writeClientReportingCache(email, snapshot) {
  if (!email || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(cacheKey(email), JSON.stringify({ ...snapshot, ts: Date.now() }));
  } catch (_err) {
    /* localStorage may be full or unavailable — non-fatal */
  }
}
